import React, { useEffect, useRef, useState } from "react";
import {
  GetEventsForCalender,
  GetOrganizerEvents,
  GetUserEventsList,
} from "../../utils/ApiConstant";
import MainComponentWrapper from "../Common/MainComponentWrapper";
import FullCalendar from "@fullcalendar/react";
import dayGridPlugin from "@fullcalendar/daygrid";
import timeGridPlugin from "@fullcalendar/timegrid";
import interactionPlugin from "@fullcalendar/interaction";
import useHttpHook from "../../Hooks/HttpHook";
import listPlugin from "@fullcalendar/list";
import { useSelector } from "react-redux";
import EditEventModal from "./EditEventModal";
import EventListModal from "./EventListModal";
import { trimString } from "../../utils/Helper";
import { toast } from "react-toastify";
import moment from "moment";
import { showErrorToast } from "../../utils/notify";

const Schedule = () => {
  // const [months, setMonths] = React.useState([]);
  const [years, setYears] = React.useState([]);
  const [defaultYear, setDefaultYear] = React.useState(0);
  const [defaultMonth, setDefaultMonth] = React.useState(0);
  const [isEditPopUpModal, setIsEditPopUpModal] = React.useState(false);
  const { userDetails } = useSelector((state) => state.user);
  const [selectedEvent, setSelectedEvent] = React.useState(null);
  const [selectedDate, setSelectedDate] = React.useState(null);
  const [event, setEvent] = useState(null);
  let months = [
    {
      id: 1,
      name: "January",
    },
    {
      id: 2,
      name: "February",
    },
    {
      id: 3,
      name: "March",
    },
    {
      id: 4,
      name: "April",
    },
    {
      id: 5,
      name: "May",
    },
    {
      id: 6,
      name: "June",
    },

    {
      id: 7,
      name: "July",
    },
    {
      id: 8,
      name: "August",
    },
    {
      id: 9,
      name: "September",
    },
    {
      id: 10,
      name: "October",
    },
    {
      id: 11,
      name: "November",
    },
    {
      id: 12,
      name: "December",
    },
  ];

  const [loading, sendRequest, error] = useHttpHook();
  const [eventsList, setEventsList] = useState([]);
  const calendarRef = useRef();
  const calenderApi = calendarRef?.current?.getApi();
  const [isListModal, setIsListModal] = useState(false);

  // console.log({ eventsList })

  useEffect(() => {
    getEvents();
  }, []);

  useEffect(() => {
    if (error) {
      if (toast.isActive(error) === false) {
        showErrorToast(error);
        if (error === "You are unAuthrised") {
          window.location.href = `${process.env.REACT_APP_MERCH_URL}/login`;
        }
      }
    }
  }, [error]);
  const getEvents = async () => {
    try {
      let calendar = await sendRequest(GetEventsForCalender, { method: "get" });
      // function capitalizeFirstLetter(string) {
      //   return string.charAt(0).toUpperCase() + string.slice(1);
      // }
      if (calendar?.status === 1) setEventsList(calendar?.data);

      // let a = [];
      // calendar?.data?.forEach((item) => {
      //   let startD = new Date(item.start);
      //   let endD = new Date(item.end);
      //   for (let i = 0; startD <= endD; startD.setDate(startD.getDate() + 1)) {
      //     a.push({
      //       ...item,
      //       start: moment.utc(startD).format("YYYY-MM-DD"),
      //       end: moment.utc(new Date(item.end)).format("YYYY-MM-DD"),
      //       title: capitalizeFirstLetter(trimString(item.title, 10)),
      //     });
      //   }
      // });
      // setEventsList(a);
    } catch (error) {
      console.log(error);
    }
  };
  useEffect(() => {
    let year = [];
    const currentYear = new Date().getFullYear();
    const currentMonth = new Date().getMonth() + 1;
    setDefaultYear(currentYear);
    setDefaultMonth(currentMonth);
    // console.log({ currentMonth })

    for (let i = 1970; i <= 2050; i++) {
      year.push(i);
      setYears(year);
    }
  }, []);

  // console.log({ calenderApi })

  const handleChanegeMonth = (e) => {
    // console.log({ month: calenderApi.getDate() })
    setDefaultMonth(e.target.value);
    calenderApi.gotoDate(new Date(`${defaultYear}-${e.target.value}-01`));
  };

  const handleChanegeYear = (e) => {
    setDefaultYear(e.target.value);
    calenderApi.gotoDate(new Date(`${defaultMonth}-01-${e.target.value}`));
  };

  const handleDateClick = (e) => {
    // console.log(e,"eeeeeeee")
    if (e.dateStr) {
      setSelectedDate(e.dateStr);
    } else {
      // setEvent(e.event._def.extendedProps._id);
      setEvent(e.event._def.publicId);
    }

    setIsListModal(true);
  };

  return (
    <MainComponentWrapper errorInfo={error} Loading={loading}>
      <div className="event-calendar-body">
        <div className="event-calendar-shell">
          <header className="event-calendar-head">
            <div className="event-calendar-head-top">
              <h1 className="event-calendar-title">
                <span className="event-calendar-title-mark">Calendar</span>
              </h1>
              <div className="event-calendar-filters">
                <select
                  className="event-calendar-select"
                  aria-label="Month"
                  onChange={handleChanegeMonth}
                  defaultValue={defaultMonth}
                >
                  {months?.map((month, index) => (
                    <option
                      key={index}
                      value={month.id}
                      selected={month.id === defaultMonth}
                    >
                      {month.name}
                    </option>
                  ))}
                </select>
                <select
                  className="event-calendar-select"
                  aria-label="Year"
                  onChange={handleChanegeYear}
                  defaultValue={defaultYear}
                >
                  {years?.map((year, index) => (
                    <option
                      key={index}
                      value={year}
                      selected={year === defaultYear}
                    >
                      {year}
                    </option>
                  ))}
                </select>
              </div>
            </div>
          </header>

          <div className="p-lr-15 mt-4 mb-4">
            <FullCalendar
              plugins={[dayGridPlugin, interactionPlugin]}
              initialView="dayGridMonth"
              events={eventsList}
              eventClick={handleDateClick}
              headerToolbar={{
                end: "prev,next",
              }}
              selectable={true}
              dateClick={handleDateClick}
              eventBorderColor="#3788d8"
              displayEventTime={false}
            />
          </div>
        </div>

        {isListModal && (
          <EventListModal
            date={selectedDate}
            eventName={event}
            handleClose={() => {
              setSelectedDate(null);
              setEvent(null);
              setIsListModal(false);
            }}
          />
        )}
      </div>
    </MainComponentWrapper>
  );
};

export default Schedule;
